// Application Configuration
export const config = {
  // API Configuration
  api: {
    // Use getter to evaluate at runtime, not build time
    get baseURL() {
      // If REACT_APP_API_URL is set, use it (for explicit configuration)
      if (process.env.REACT_APP_API_URL) {
        return process.env.REACT_APP_API_URL;
      }
      
      // Otherwise, use the current window location to build the API URL
      // This works for both localhost and IP addresses from other devices
      if (typeof window !== 'undefined' && window.location) {
        const protocol = window.location.protocol;
        const host = window.location.host;
        return `${protocol}//${host}/api`;
      }
      
      // Fallback for SSR or build time
      return '/api';
    },
    timeout: parseInt(process.env.REACT_APP_API_TIMEOUT || '30000', 10),
  },

  // Application Info
  app: {
    name: process.env.REACT_APP_NAME || 'Sab Lassie E-commerce',
    version: process.env.REACT_APP_VERSION || '1.0.0',
    env: process.env.REACT_APP_ENV || 'development',
  },

  // Feature Flags
  features: {
    analytics: process.env.REACT_APP_ENABLE_ANALYTICS === 'true',
    errorReporting: process.env.REACT_APP_ENABLE_ERROR_REPORTING === 'true',
  },

  // Pagination
  pagination: {
    defaultPageSize: parseInt(process.env.REACT_APP_DEFAULT_PAGE_SIZE || '12', 10),
  },

  // Image Upload
  upload: {
    maxSize: parseInt(process.env.REACT_APP_IMAGE_MAX_SIZE || '5000000', 10),
    allowedTypes: (process.env.REACT_APP_IMAGE_ALLOWED_TYPES || 'jpg,jpeg,png,webp').split(','),
  },

  // Payment Configuration
  payment: {
    paystackPublicKey: process.env.REACT_APP_PAYSTACK_PUBLIC_KEY || '',
  },
};

// Export default for easy import
export default config;

